var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: _vm.classes
  }, [_vm.actionsState == 'default' ? [_c('a', {
    staticClass: "editable-hover",
    on: {
      "click": _vm.edit
    }
  }, [_vm._t("default")], 2), _c('editable-actions', {
    attrs: {
      "state": _vm.actionsState,
      "edit-action-display-type": _vm.editActionDisplayType
    },
    on: {
      "edit": _vm.edit,
      "submit": _vm.submit,
      "cancel": _vm.cancel
    }
  })] : _vm._e(), _vm.actionsState == 'edit' ? [_c('Superselect', {
    attrs: {
      "options": _vm.options,
      "placeholder": "Select One",
      "title": "Protocol",
      "multiple": false,
      "show-labels": false,
      "allow-empty": false,
      "loading": _vm.$apollo.loading
    },
    on: {
      "input": _vm.submit
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }), _c('editable-actions', {
    attrs: {
      "submitting": _vm.isSubmitting,
      "state": _vm.actionsState
    },
    on: {
      "edit": _vm.edit,
      "submit": _vm.submit,
      "cancel": _vm.cancel
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }